/* =========================================================
   RoyalArt — premium.js
   Smooth scroll (Lenis) · 3D tilt · magnetic buttons
   · parallax depth · gold scroll-progress bar
   No build step. Defer-loaded. Degrades gracefully.
   ========================================================= */
(function () {
  "use strict";

  function $all(sel, ctx) {
    return Array.prototype.slice.call((ctx || document).querySelectorAll(sel));
  }
  function mq(q) { return window.matchMedia(q).matches; }

  var reduce = mq("(prefers-reduced-motion: reduce)");
  var finePointer = mq("(pointer: fine)");
  var rafThrottle = function (fn) {
    var ticking = false;
    return function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { fn(); ticking = false; });
    };
  };

  /* ---------- 1. Gold scroll-progress bar ---------- */
  function scrollProgress() {
    var bar = document.createElement("div");
    bar.className = "scroll-progress";
    bar.setAttribute("aria-hidden", "true");
    document.body.appendChild(bar);
    var d = document.documentElement;
    function update() {
      var max = d.scrollHeight - d.clientHeight;
      var p = max > 0 ? (window.scrollY || window.pageYOffset) / max : 0;
      bar.style.transform = "scaleX(" + p.toFixed(4) + ")";
    }
    update();
    window.addEventListener("scroll", rafThrottle(update), { passive: true });
    window.addEventListener("resize", rafThrottle(update));
  }

  /* ---------- 2. Interactive 3D tilt on art media ---------- */
  function tilt() {
    if (!finePointer || reduce) return;
    var MAX = 12; // degrees
    $all(".cat-tile__media, .tile__media, [data-tilt]").forEach(function (el) {
      el.classList.add("is-tilt");
      el.addEventListener("pointermove", function (e) {
        var b = el.getBoundingClientRect();
        var x = (e.clientX - b.left) / b.width - 0.5;
        var y = (e.clientY - b.top) / b.height - 0.5;
        el.style.setProperty("--ry", (x * MAX).toFixed(2) + "deg");
        el.style.setProperty("--rx", (-y * MAX).toFixed(2) + "deg");
        el.style.setProperty("--gx", (x * 100 + 50).toFixed(1) + "%");
        el.style.setProperty("--gy", (y * 100 + 50).toFixed(1) + "%");
      });
      el.addEventListener("pointerleave", function () {
        el.style.setProperty("--rx", "0deg");
        el.style.setProperty("--ry", "0deg");
      });
    });
  }

  /* ---------- 3. Magnetic buttons (hero CTAs) ---------- */
  function magnetic() {
    if (!finePointer || reduce) return;
    var STRENGTH = 0.28;
    var targets = $all("[data-magnetic]");
    $all(".hero__cta .btn").forEach(function (b) { if (targets.indexOf(b) === -1) targets.push(b); });
    targets.forEach(function (el) {
      el.setAttribute("data-magnetic", "");
      el.addEventListener("pointermove", function (e) {
        var b = el.getBoundingClientRect();
        el.style.setProperty("--mx", ((e.clientX - b.left - b.width / 2) * STRENGTH).toFixed(1) + "px");
        el.style.setProperty("--my", ((e.clientY - b.top - b.height / 2) * STRENGTH).toFixed(1) + "px");
      });
      el.addEventListener("pointerleave", function () {
        el.style.setProperty("--mx", "0px");
        el.style.setProperty("--my", "0px");
      });
    });
  }

  /* ---------- 4. Parallax depth ---------- */
  function parallax() {
    if (reduce) return;
    var els = $all(".hero__media, [data-parallax]");
    if (!els.length) return;
    function update() {
      var vh = window.innerHeight;
      els.forEach(function (el) {
        var b = el.getBoundingClientRect();
        var center = b.top + b.height / 2;
        var off = (center - vh / 2) / vh; // -0.5..0.5 across viewport
        var amt = parseFloat(el.getAttribute("data-parallax-amt") || "16");
        el.style.setProperty("--py", (-off * amt).toFixed(1) + "px");
      });
    }
    update();
    window.addEventListener("scroll", rafThrottle(update), { passive: true });
    window.addEventListener("resize", rafThrottle(update));
  }

  /* ---------- 5. Smooth scroll (Lenis) — desktop only ---------- */
  function smoothScroll() {
    if (reduce || !finePointer || !mq("(min-width: 1025px)")) return;
    var s = document.createElement("script");
    s.src = "https://cdn.jsdelivr.net/npm/lenis@1/dist/lenis.min.js";
    s.onload = function () {
      if (!window.Lenis) return;
      var lenis = new window.Lenis({ duration: 1.1, smoothWheel: true, wheelMultiplier: 1 });
      function raf(t) { lenis.raf(t); window.requestAnimationFrame(raf); }
      window.requestAnimationFrame(raf);
      // pause smoothing while a drawer/panel locks the page
      var mo = new MutationObserver(function () {
        if (document.body.classList.contains("is-locked")) lenis.stop();
        else lenis.start();
      });
      mo.observe(document.body, { attributes: true, attributeFilter: ["class"] });
    };
    s.onerror = function () { /* native scroll remains */ };
    document.head.appendChild(s);
  }

  function init() {
    scrollProgress();
    tilt();
    magnetic();
    parallax();
    smoothScroll();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
